<div class="row mb-4">
  <div class="col">
    <h2 class="text-primary" i18n="Label users">Users</h2>
  </div>
  <div *ngIf="auth.isAnyAdmin$ | async" class="col-auto d-flex align-items-center">
    <!--<app-import-export *ngIf="auth.isTenantAdmin$ | async" class="me-2"
      filenamePrefix="users"
      [importFactory]="importFactory"
      [exportFactory]="exportFactory"></app-import-export>-->

  </div>
</div>
<app-filter-string (filterEmiter)=searchSubmit($event)>
</app-filter-string>
<div class="row mb-4">
  <div class="col-12 col-md mb-3 mb-md-0 pagination-wrapper">
    <app-pagination [page]="(repo.pageNumber$ | async) || 1"
                    [total]="(repo.paginationData$ | async)?.lastPage || 0"
                    (pageChange)="service.loadPageWithFilter($event, 10 , '' , filter).subscribe()"></app-pagination>
  </div>
  <div class="col-12 col-md-auto">
    <app-sort-dropdown [sortingOptions]="sortOptions"
                       [sorting]="repo.sort$ | async"
                       (sortingChange)="service.sortWithFilter($event, '' ,filter).subscribe()"></app-sort-dropdown>
  </div>
</div>

<div class="row mb-4">
  <div class="col">
    <app-spinner *ngIf="repo.isLoading$ | async"></app-spinner>
    <app-users-list [users]="repo.page$ | async"
                    [tenants]="tenantRepo.tenants$ | async"
                    [authUserRoles]="this.auth.roles$ | async"></app-users-list>
  </div>
</div>
